import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Statistic } from 'antd';
import { resendCodeApi, verifyApi } from '@http/auth';
import { useAppDispatch, useAppSelector } from '@hooks/redux';
import { useTranslation } from 'react-i18next';
import Header from './components/header';
import FooterNew from '@components/Container/Footer-new';

const { Countdown } = Statistic;

const GoogleIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='48' height='48'>
    <path
      d='M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z'
      fill='#4285F4'
    />
    <path
      d='M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z'
      fill='#34A853'
    />
    <path
      d='M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z'
      fill='#FBBC05'
    />
    <path
      d='M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z'
      fill='#EA4335'
    />
  </svg>
);

function OtpCode() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [time, setTime] = useState(false);
  const otpLifeTime = useAppSelector(state => state.appReducer.otpLifeTime);
  const otpType = useAppSelector(state => state.appReducer.otpType);
  const isGoogleAuth = useAppSelector(state => state.appReducer.isGoogleAuth);

  const onFinish = async (values: any) => {
    dispatch(verifyApi({ code: values.code }, navigate));
  };

  const onFinishCountDown = () => {
    setTime(true);
  };

  return (
    <div
      className='bg-white'
      style={{ height: '100vh', display: 'grid', gridTemplateColumns: '1fr', gridTemplateRows: 'auto 1fr auto' }}
    >
      <Header />
      <main className='flex items-center justify-center py-12'>
        <div className='w-[340px] lg:w-[480px]'>
          <div className='text-center mb-7'>
            <p className='text-2xl'>{t('OtpCode')}</p>
          </div>

          {isGoogleAuth && (
            <div
              className='flex flex-col items-center gap-3 mb-6 p-4 rounded-xl'
              style={{ background: '#f0f6ff', border: '1px solid #d0e4ff' }}
            >
              <GoogleIcon />
              <p className='text-sm text-center text-slate-600 m-0'>{t('Google auth otp description')}</p>
            </div>
          )}

          <Form name='otpCode' initialValues={{ remember: true }} onFinish={onFinish} autoComplete='off'>
            <Form.Item className='mb-5' name='code' rules={[{ required: true, message: `${t('Required')}` }]}>
              <Input className='auth__input-primary text-lg' style={{ width: '100%' }} placeholder={`${t('Code')}`} />
            </Form.Item>

            {!isGoogleAuth && (
              <>
                {!time ? (
                  <div className='text-xs lg:text-sm flex items-center text-slate-400 justify-center mb-2'>
                    <span className='mr-2 text-right'>{t('ResendTime')}</span>
                    <Countdown
                      className='!text-xs'
                      style={{ fontSize: 12 }}
                      value={otpLifeTime}
                      onFinish={onFinishCountDown}
                      format='mm:ss'
                    />
                    <span className='ml-2'>{t('Second')}!</span>
                  </div>
                ) : (
                  <Button
                    className='mb-3'
                    size='middle'
                    onClick={() => {
                      setTime(false);
                      dispatch(resendCodeApi({ otp_delivery: otpType }));
                    }}
                  >
                    {t('ResendCode')}
                  </Button>
                )}
                <p className='text-center'>
                  {t(`${otpType === 'sms' ? 'Sent code to phone for sequirity' : 'Sent code to email for sequirity'}`)}
                </p>
              </>
            )}

            <Form.Item>
              <div className='flex justify-end mt-5'>
                <Button className='auth__btn-primary text-lg w-full' type='primary' htmlType='submit'>
                  {t('Sign in')}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </main>
      <div className='max-lg:hidden mt-10' style={{ borderTop: '1px solid #eee' }}>
        <FooterNew />
      </div>
    </div>
  );
}

export default OtpCode;
